import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="bg-gradient-to-br from-purple-100 via-purple-200 to-purple-100 pt-16 pb-8 px-6 md:px-16 rounded-t-3xl shadow-glass">
      {/* 上方三列：Logo / Quick Links / Contacts */}
      <div className="max-w-6xl mx-auto grid gap-10 text-purple-900 md:grid-cols-3 md:items-start">
        {/* Logo + Slogan */}
        <div>
          <Link
            to="/"
            onClick={scrollToTop}
            className="inline-flex items-center gap-2"
          >
            <img
              src="/ainova_logo_white.png"
              alt="AI NOVA"
              className="h-12 mb-4"
            />
          </Link>
          <p className="text-purple-800/70 text-sm">
            Driving digital transformation through intelligent, scalable, and future-ready ecosystem
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-extrabold text-lg border-b-2 border-primary inline-block mb-3">
            Quick Links
          </h4>

          <div className="grid grid-cols-2 gap-x-10 gap-y-1">
            <Link
              to="/about"
              onClick={scrollToTop}
              className="block text-purple-800/70 hover:text-purple-900 cursor-pointer"
            >
              About Us
            </Link>
            <Link
              to="/investor"
              onClick={scrollToTop}
              className="block text-purple-800/70 hover:text-purple-900 cursor-pointer"
            >
              Investors
            </Link>
            <Link
              to="/our-pillars"
              onClick={scrollToTop}
              className="block text-purple-800/70 hover:text-purple-900 cursor-pointer"
            >
              Our Pillars
            </Link>
            <Link
              to="/team"
              onClick={scrollToTop}
              className="block text-purple-800/70 hover:text-purple-900 cursor-pointer"
            >
              Our Team
            </Link>
            <Link
              to="/our-solutions"
              onClick={scrollToTop}
              className="block text-purple-800/70 hover:text-purple-900 cursor-pointer"
            >
              Our Solutions
            </Link>
            <Link
              to="/partners"
              onClick={scrollToTop}
              className="block text-purple-800/70 hover:text-purple-900 cursor-pointer"
            >
              Our Partners
            </Link>
            <Link
              to="/our-reach"
              onClick={scrollToTop}
              className="block text-purple-800/70 hover:text-purple-900 cursor-pointer"
            >
              Our Reach
            </Link>

            <Link
              to="/news"
              onClick={scrollToTop}
              className="block text-purple-800/70 hover:text-purple-900 cursor-pointer"
            >
              News & Events
            </Link>
          </div>
        </div>

        {/* Contacts */}
        <div>
          <h4 className="font-extrabold text-lg border-b-2 border-primary inline-block mb-3">
            Contact
          </h4>
          <p className="text-purple-800/80">
            <strong>Email:</strong>{" "}
            <a
              href="mailto:getintouch@ainova.sg"
              className="hover:text-purple-900"
            >
              getintouch@ainova.sg
            </a>
          </p>
          <p className="text-purple-800/80">
            <strong>Address:</strong> 8 Marina Boulevard #29-01, MBFC, Singapore
            018981.
          </p>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="mt-10 pt-6 border-t border-purple-300/50 flex flex-wrap justify-between items-center gap-4 text-sm text-purple-700 max-w-6xl mx-auto">
        <p>©2025 AINOVA. All Rights Reserved.</p>
        <div className="flex gap-8">
          <Link
            to="/privacy"
            onClick={scrollToTop}
            className="hover:text-purple-900 cursor-pointer"
          >
            Privacy Policy
          </Link>
          {/* 如果以后要加 terms 再解开 */}
          {/* <Link
            to="/terms"
            onClick={scrollToTop}
            className="hover:text-purple-900 cursor-pointer"
          >
            Terms & Conditions
          </Link> */}
        </div>
      </div>
    </footer>
  );
}
